/**
 * 包含一些常量值的模块
 */
export const PAGE_SIZE = 10

